import React__default from 'react';
import { useIntl } from '@grandvisionhq/state';
import { TileLayout } from '../../TileLayout/TileLayout.js';
import { FacetLink } from '../components/FacetLink.js';

const FrameSizeFacet = ({ item , isActive , className , onPick , productType ,  })=>{
    const { getLabel  } = useIntl();
    const tileSubtitle = React__default.useMemo(()=>{
        switch(item.facetTerm){
            case 'LARGE':
                return getLabel('products.facets.frameSize.wide.subTitle');
            case 'MEDIUM':
                return getLabel('products.facets.frameSize.average.subTitle');
            case 'SMALL':
                return getLabel('products.facets.frameSize.narrow.subTitle');
            case 'EXTRA_SMALL':
                return getLabel('products.facets.frameSize.kids.subTitle');
            default:
                return undefined;
        }
    }, [
        getLabel,
        item.facetTerm
    ]);
    const tileTitle = React__default.useMemo(()=>{
        switch(item.facetTerm){
            case 'LARGE':
                return getLabel('products.facets.frameSize.wide.title');
            case 'MEDIUM':
                return getLabel('products.facets.frameSize.average.title');
            case 'SMALL':
                return getLabel('products.facets.frameSize.narrow.title');
            case 'EXTRA_SMALL':
                return getLabel('products.facets.frameSize.kids.title');
            default:
                return `${item.facetTerm}`;
        }
    }, [
        getLabel,
        item.facetTerm
    ]);
    return /*#__PURE__*/ React__default.createElement(FacetLink, {
        item: item,
        isActive: isActive,
        onPick: onPick,
        className: className,
        productType: productType
    }, /*#__PURE__*/ React__default.createElement(TileLayout, {
        title: tileTitle,
        subtitle: tileSubtitle
    }));
};

export { FrameSizeFacet };
//# sourceMappingURL=FrameSizeFacet.js.map
